import { schema } from "normalizr";

const WidgetSchema = new schema.Entity("widgets");
const WidgetArraySchema = new schema.Array(WidgetSchema);

export { WidgetSchema, WidgetArraySchema };